module.exports = __webpack_public_path__ + "img/gonetwork2_8.52f0fb78.png";